module.exports = __webpack_public_path__ + "img/filter2.b45cf012.svg";